import mixins from 'vue-typed-mixins';

import { Eフェーズ種別 } from '@/openapi/enum';

import 業績予測CF計算書 from '@/entries/user/pages/authorized/事業所/計画書/モニタリング/業績予測/CF計算書/業績予測CF計算書.vue';
import 業績予測損益計算書 from '@/entries/user/pages/authorized/事業所/計画書/モニタリング/業績予測/損益計算書/業績予測損益計算書.vue';
import 業績予測貸借対照表 from '@/entries/user/pages/authorized/事業所/計画書/モニタリング/業績予測/貸借対照表/業績予測貸借対照表.vue';

import C勘定科目ListEditModeToggleButton from '@/components/勘定科目/listEdit/button/modeToggle/勘定科目ListEditModeToggleButton.vue';
import C勘定科目ListEditNewButton from '@/components/勘定科目/listEdit/button/new/勘定科目ListEditNewButton.vue';
import C勘定科目ListEditDialog from '@/components/勘定科目/listEdit/dialog/勘定科目ListEditDialog.vue';

import PlbscfKeystrokeResetMixin from '@/entries/user/mixins/PlbscfKeystrokeResetMixin';
import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 業績予測Mixin from '@/entries/user/mixins/業績予測Mixin';
import 計画Plbscf業績予測Mixin from '@/entries/user/mixins/計画Plbscf業績予測Mixin';
import EventObserverMixin from '@/mixins/EventObserverMixin';

import { TデータPlbscf } from '@/classes/service/AbstractPlbscfService';
import 業績予測Service from '@/classes/service/モニタリング/業績予測Service';
import { PlbscfType } from '@/master/Plbscf';

export default mixins(
  EventObserverMixin,
  PlbscfKeystrokeResetMixin,
  RoutesMixin,
  計画Plbscf業績予測Mixin,
  業績予測Mixin
).extend({
  name: 'P業績予測',

  components: {
    tab0: 業績予測貸借対照表,
    tab1: 業績予測損益計算書,
    tab2: 業績予測CF計算書,
    C勘定科目ListEditNewButton,
    C勘定科目ListEditModeToggleButton,
    C勘定科目ListEditDialog,
  },

  data(): {
    tabTypes: PlbscfType[];
    service: 業績予測Service;
  } {
    return {
      tabTypes: [PlbscfType.貸借対照表, PlbscfType.損益計算書, PlbscfType.CF計算書],
      service: new 業績予測Service(Eフェーズ種別.モニタリングフェーズ),
    };
  },

  computed: {
    canEdit勘定科目(): boolean {
      return !this.isCF計算書Tab && !this.is科目別損益計算表;
    },
    tデータPlbscfsToSave(): TデータPlbscf[] {
      return this.service.getTデータPlbscfs.filter((t) => t.番号 === this.モニタリング会計期間Year);
    },
  },

  watch: {
    async isEditing(): Promise<void> {
      if (!this.isEditing) return;
      await this.saveデータ(
        this.tデータPlbscfsToSave,
        this.service.getTデータ科目別計画Configs,
        Eフェーズ種別.モニタリングフェーズ
      );

      // 再load or 再計算
      if (this.reloadFlag) {
        await this.load();
      } else {
        this.計画Plbscf = this.service.calcAndCreate計画Plbscf();
        this.initializeFlag();
      }
    },
    eventCount(): void {
      // EventObserverMixin.eventCount を監視、一覧での勘定科目並び順変更、削除、科目別計画フラグの活性化　を想定
      this.load();
    },
  },

  async created(): Promise<void> {
    await this.loadAndResetKeystroke();
  },

  methods: {
    async load(): Promise<void> {
      await this.loadByService(this.service);
      this.setReadonlyMonthIndex();
    },
    onChange表示設定(): void {
      this.計画Plbscf = this.service.create計画Plbscf();
      this.initializeFlag();
      this.addKeystrokeResetCount();
    },
    async loadAndResetKeystroke(): Promise<void> {
      await this.load();
      this.addKeystrokeResetCount();
    },
  },
});
